import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { useCurrentEnterpriseTaxations } from '@mews-commander/legacy-entities/src/selectors/taxEnvironments';
import { LabeledListItem, SpacedComma } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { useLocalizeTaxRate } from '../../../hooks/useLocalizeTaxRate';

interface TaxationListProps {
    taxRateCodes: string[];
}

export const TaxationList = ({ taxRateCodes }: TaxationListProps) => {
    const taxations = useCurrentEnterpriseTaxations();
    const localizeTaxRate = useLocalizeTaxRate();

    return (
        <>
            {taxations.map(({ name, code }) => (
                <LabeledListItem label={name} key={code}>
                    {taxRateCodes.length > 0
                        ? pipe(taxRateCodes, array.filterMap(localizeTaxRate), (localizedTaxRates) => (
                              <>{localizedTaxRates.map(({ label }) => label).join(SpacedComma)}</>
                          ))
                        : UnicodeEntity.Dash}
                </LabeledListItem>
            ))}
        </>
    );
};
